import { CellClassParams, HeaderClassParams } from "@ag-grid-community/core";
import clsx from "clsx";
import { AllocationRuleInvestingEntitiesData } from "gen/model/allocationRuleInvestingEntitiesData";
import { first } from "lodash-es";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { DataTable } from "shared/components/table/data/DataTable";
import {
  OnChangeFn,
  RowSelectionState,
} from "shared/components/table/data/DataTableTypes";
import { getRootGenericTableColumFromAgColumn } from "shared/components/table/data/DataTableUtils";
import { useMaybernTableUIContext } from "shared/components/table/maybern/MaybernTableUIContext";
import { tryGetAgGridApi } from "shared/components/table/maybern/MaybernTableUtils";

export const AllocationSetupInvestorsTable: React.FC<{
  fundFamilyId: string;
  allocationRuleId: string;
  rowSelection: RowSelectionState;
  currentInvestingEntityData: AllocationRuleInvestingEntitiesData;
  onRowSelectionChanged: OnChangeFn<RowSelectionState>;
}> = ({ currentInvestingEntityData, allocationRuleId }) => {
  const { t } = useTranslation(["allocation"]);

  const { agGrid } = useMaybernTableUIContext();

  // Horizontally scroll to the column group for the selected allocation rule
  useEffect(() => {
    const api = tryGetAgGridApi(agGrid);
    const colGroup = api?.getColumnGroup(allocationRuleId);
    const firstCol = first(colGroup?.getChildren());
    if (firstCol) {
      api?.ensureColumnVisible(firstCol.getUniqueId(), "middle");
    }
  }, [agGrid, allocationRuleId]);

  const isHighlighted = (params: HeaderClassParams | CellClassParams) =>
    getRootGenericTableColumFromAgColumn(params.column)?.id ===
    allocationRuleId;

  return (
    <DataTable
      data={currentInvestingEntityData.commitments}
      emptyStateProps={{
        title: t("allocation:setup.entities.investors.empty"),
      }}
      headerOrCellClass={(params) =>
        clsx({
          "mb-cell-highlighted": isHighlighted(params),
        })
      }
    />
  );
};
